import { c as _c } from "react/compiler-runtime";
import { EntitiesToolbar } from "@components/common/toolbar/entities-toolbar";
import { DEFAULT_TEAMS_SORT_BY } from "@components/teams/teams-constants";
import { TeamsSort } from "@components/teams/teams-sort";
import { isTeamsSortBy } from "@custom-types/type-guards";
import { useSubjectsSortByQuery } from "@hooks/use-subjects-sort-by-query";
import { TeamsDetails } from "@pages/members/teams/teams-details";
import { shouldShowTeamsPremiumPage, TeamsPremiumFeaturePage } from "@pages/members/teams/teams-premium-feature-page";
import { useTeamsPageBulkActions } from "@pages/members/teams/use-teams-page-bulk-actions";
import { TeamsTableWrapper } from "@pages/members/teams/teams-table-wrapper";
import { CreateTeam } from "@pages/members/teams/create-team";
import { canUseTeamsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { allTeamsSelector, fetchingTeamsFlagsSelector, teamsSelector } from "@store/teams/teams-selector";
import { fetchTeams } from "@store/teams/teams-slice-thunk";
import { getExportComponent } from "@utils/member-utils";
import { sortTeams } from "@utils/team-utils";
import { useEffect, useMemo } from "react";

/**
 * The component that will render the kpi details and the table for the teams
 */
export function Teams(t0) {
  const $ = _c(36);
  const {
    companyId
  } = t0;
  const teams = useAppSelector(teamsSelector);
  const allTeams = useAppSelector(allTeamsSelector);
  const {
    status
  } = useAppSelector(fetchingTeamsFlagsSelector);
  const dispatch = useAppDispatch();
  const canUseTeams = useAppSelector(canUseTeamsSelector);
  const isLoading = status === "pending" || status === "uninitialized";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultSort: DEFAULT_TEAMS_SORT_BY,
      isValidSort: isTeamsSortBy
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    sortBy,
    setSortBy
  } = useSubjectsSortByQuery(t1);
  let t2;
  if ($[1] !== sortBy || $[2] !== teams) {
    t2 = sortTeams(teams, sortBy);
    $[1] = sortBy;
    $[2] = teams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const sortedTeams = t2;
  let t3;
  let t4;
  if ($[4] !== dispatch) {
    t3 = () => {
      const searchTeams = async function searchTeams() {
        await dispatch(fetchTeams({
          searchText: ""
        }));
      };
      searchTeams();
    };
    t4 = [dispatch];
    $[4] = dispatch;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== companyId || $[8] !== teams) {
    t5 = {
      companyId,
      teams
    };
    $[7] = companyId;
    $[8] = teams;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const buttonComponents = useTeamsPageBulkActions(t5);
  const shouldRenderActions = sortedTeams.length > 0;
  if (shouldShowTeamsPremiumPage({
    canUseTeams,
    teams: allTeams,
    status
  })) {
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <TeamsPremiumFeaturePage />;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TeamsDetails />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = teams.length;
  let t8;
  if ($[12] !== shouldRenderActions) {
    t8 = shouldRenderActions && <CreateTeam />;
    $[12] = shouldRenderActions;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== setSortBy || $[15] !== shouldRenderActions || $[16] !== sortBy) {
    t9 = shouldRenderActions && <TeamsSort key="teams-sort" sortBy={sortBy} setSortBy={setSortBy} />;
    $[14] = setSortBy;
    $[15] = shouldRenderActions;
    $[16] = sortBy;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== buttonComponents.export || $[19] !== teams.length) {
    t10 = getExportComponent(teams.length, buttonComponents.export);
    $[18] = buttonComponents.export;
    $[19] = teams.length;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== isLoading || $[22] !== t10 || $[23] !== t8 || $[24] !== t9 || $[25] !== teams.length) {
    t11 = <EntitiesToolbar toolbarEntityName="Team" numberOfRows={t7} isLoading={isLoading} mobileAction={t8} sortActions={t9} exportComponent={t10} />;
    $[21] = isLoading;
    $[22] = t10;
    $[23] = t8;
    $[24] = t9;
    $[25] = teams.length;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== buttonComponents || $[28] !== companyId || $[29] !== setSortBy || $[30] !== sortBy || $[31] !== sortedTeams) {
    t12 = <TeamsTableWrapper companyId={companyId} sortedTeams={sortedTeams} buttonComponents={buttonComponents} sortBy={sortBy} setSortBy={setSortBy} />;
    $[27] = buttonComponents;
    $[28] = companyId;
    $[29] = setSortBy;
    $[30] = sortBy;
    $[31] = sortedTeams;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t11 || $[34] !== t12) {
    t13 = <>{t6}{t11}{t12}</>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
}